::ng-deep contact-selector{max-height:500px;overflow:auto}::ng-deep contact-selector .each-item-container{border-bottom:0px!important}
/*# sourceMappingURL=manage-participants-dialog.component-KE56C7E6.css.map */
